module.exports = __webpack_public_path__ + "img/apolar-procura-banner.9e2991d9.png";